import {
  AppointmentType,
  AppointmentsStatus,
  FLOW_MODES,
} from '@avanta/shared/constants/appointments';
import {
  type AppointmentTypeValue,
  type AppointmentDurationValue,
  type AppointmentPayload,
  type EditAppointmentPayload,
  type Speciality,
  type Center,
  type DailySlot,
  type Appointment,
  type AppointmentStatus,
  type CancelAppointmentPayload,
  type SessionDetails,
  type Flow,
  type TopPsychologist,
  type BookingOptions,
} from '@avanta/shared/types/appointments';
import { type Psychologist } from '@avanta/shared/types/psychologists';
import { type User } from '@avanta/shared/types/users';

export {
  AppointmentType,
  type AppointmentTypeValue,
  type AppointmentDurationValue,
  type AppointmentPayload,
  type EditAppointmentPayload,
  type Speciality,
  type Center,
  type DailySlot,
  type Appointment,
  type AppointmentStatus,
  type CancelAppointmentPayload,
  type SessionDetails,
  AppointmentsStatus,
  FLOW_MODES,
  type Flow,
  type TopPsychologist,
  type BookingOptions,
};

export const AppointmentSteps = {
  speciality: 'speciality',
  schedule: 'schedule',
  psychologist: 'psychologist',
  payment: 'payment',
  resume: 'resume',
  //legacy steps
  profile: 'profile',
  reasons: 'reasons',
  type: 'type',
  city: 'city',
  center: 'center',
  data: 'data',
} as const;

export type Steps = keyof typeof AppointmentSteps;

export interface AppointmentRatingPayload {
  psychologist_id: string;
  patient_id: string;
  session: SessionDetails;
}

export interface RecentPsychologist {
  psychologist: Psychologist;
  specialitiesBookable: number;
  centerId: number;
  center?: Center;
}

export interface AppointmentHistoricalPsychoDTO {
  patient: {
    id: string;
    firstName: string;
    surname: string;
    email: string;
    nickname?: string;
    banned: boolean;
    contactPhone?: string;
    totalNumberOfSession?: number;
  };
  specialitiesBookable: number;
  centerId: number;
}

export type AppointmentHistoricalPsychoWithCenter = AppointmentHistoricalPsychoDTO & {
  center?: Center;
};

interface RecentChat {
  publishKey: string | null;
  subscribeKey: string | null;
  channelName: string;
  userId: string;
  lastSessionAt: string;
}

export type RecentPatientDTO = User & {
  daysFromLastSession: number;
  recentChat?: RecentChat;
};
